/**
 * Engagement Analytics Service
 * Handles API calls for engagement analytics data
 */

/**
 * Fetch engagement analytics data from the API
 */
export const fetchEngagementAnalytics = async (
  apiUrl = process.env.REACT_APP_API_URL || 'https://devserver.spatialgrid.ai/api/v1'
) => {
  try {
    const token = localStorage.getItem('accessToken') || localStorage.getItem('token');
    
    if (!token) {
      throw new Error('No authentication token found. Please login again.');
    }
    
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    };

    const response = await fetch(
      `${apiUrl}/analytics/engagement`,
      {
        method: 'GET',
        headers,
        credentials: 'include',
      }
    );

    if (!response.ok) {
      if (response.status === 401) {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('token');
        throw new Error('Session expired. Please login again.');
      }
      throw new Error(`Failed to fetch engagement analytics: ${response.status} ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching engagement analytics:', error);
    throw error;
  }
};

/**
 * Fetch engagement metrics for a specific page
 */
export const fetchPageEngagementMetrics = async (
  page,
  apiUrl = process.env.REACT_APP_API_URL || 'https://devserver.spatialgrid.ai/api/v1'
) => {
  try {
    const token = localStorage.getItem('accessToken') || localStorage.getItem('token');
    
    if (!token) {
      throw new Error('No authentication token found. Please login again.');
    }
    
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    };

    const response = await fetch(
      `${apiUrl}/analytics/engagement/page?page=${encodeURIComponent(page)}`,
      {
        method: 'GET',
        headers,
        credentials: 'include',
      }
    );

    if (!response.ok) {
      if (response.status === 401) {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('token');
        throw new Error('Session expired. Please login again.');
      }
      throw new Error(`Failed to fetch page metrics: ${response.status} ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching page engagement metrics:', error);
    throw error;
  }
};

/**
 * Calculate engagement rate from bounce rate
 */
export const calculateEngagementRate = (bounceRate) => {
  return ((100 - bounceRate) || 0).toFixed(2);
};

/**
 * Format bounce rate color based on percentage
 */
export const getBounceRateColor = (bounceRate) => {
  const rate = parseFloat(bounceRate);
  if (rate > 40) return '#ef4444'; // red
  if (rate > 25) return '#f59e0b'; // amber
  return '#10b981'; // green
};
